import React from 'react';
import { Target } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface Step5Data {
  core_message: string;
}

interface Step5CoreMessageProps {
  data: Step5Data;
  onChange: (data: Step5Data) => void;
}

export function Step5CoreMessage({ data, onChange }: Step5CoreMessageProps) {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <p className="text-sm text-blue-800">
          Dit wordt de basis van alle content. Het terugkerende thema in je verhaal.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Target className="w-4 h-4" />
          Als je één ding wilt dat mensen onthouden, wat is dat dan?
        </label>
        <p className="text-sm text-gray-600 mb-3">
          Wat is de rode draad in alles wat je doet?
        </p>
        <textarea
          value={data.core_message}
          onChange={(e) => onChange({ ...data, core_message: e.target.value })}
          rows={4}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="Lekker brood hoeft niet moeilijk te zijn. Gewoon eerlijk ambacht, zonder gedoe. Vers bij je thuis, zodat jij lekker kunt genieten."
          autoFocus
        />
        <AnswerQualityHint length={data.core_message.trim().length} />
      </div>
    </div>
  );
}
